import styled from 'styled-components';

export const StyledAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  grid-gap: 10px;
  text-align: initial;
  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: initial;
    text-align: center;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  form {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    width: 360px;
    .MuiFormControl-root {
      width: 100%;
      margin-bottom: 10px;
      svg {
        width: 0.7em;
      }
    }

    @media (max-width: 380px) {
      width: 250px;
    }
  }
`;

export const ContainerForBanner = styled(Container)`
  align-items: initial;
  @media (max-width: 1200px) {
    text-align: center;
  }
`;
